import { Search, X } from "lucide-react";
import { CLASSES, STATES } from "@/lib/pls";

const Chip = ({ active, onClick, children, color, testid }) => (
  <button onClick={onClick} aria-pressed={active} data-testid={testid}
    className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${active ? "border-ink bg-ink text-white" : "border-slate-200 bg-white text-slate-700 hover:border-sky-600"}`}>
    {color && <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} />}
    {children}
  </button>
);

const toggle = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);

export const PlsFilters = ({ f, setF, classCounts, stateCounts }) => (
  <div className="space-y-4" data-testid="pls-filters">
    <label className="relative block">
      <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
      <input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Search name, ICAO, IATA or town"
        className="w-full rounded-full border border-slate-200 bg-white py-3.5 pl-12 pr-12 text-base text-ink outline-none focus:border-sky-600" data-testid="pls-search-input" />
      {f.q && <button onClick={() => setF({ ...f, q: "" })} className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Clear search" data-testid="pls-search-clear"><X className="h-4 w-4" /></button>}
    </label>
    <div className="flex flex-wrap gap-2">
      {Object.entries(CLASSES).map(([k, c]) => (
        <Chip key={k} active={f.classes.includes(k)} color={c.color} onClick={() => setF({ ...f, classes: toggle(f.classes, k) })} testid={`pls-class-${k}`}>
          {c.label} <span className="opacity-60">{classCounts[k] ?? 0}</span>
        </Chip>
      ))}
      <Chip active={f.ersaOnly} onClick={() => setF({ ...f, ersaOnly: !f.ersaOnly })} testid="pls-ersa-toggle">ERSA listed</Chip>
    </div>
    <div className="flex flex-wrap gap-2">
      {STATES.map((s) => (
        <Chip key={s} active={f.states.includes(s)} onClick={() => setF({ ...f, states: toggle(f.states, s) })} testid={`pls-state-${s}`}>
          {s} <span className="opacity-60">{stateCounts[s] ?? 0}</span>
        </Chip>
      ))}
      {(f.states.length > 0 || f.classes.length > 0 || f.ersaOnly || f.q) && (
        <button onClick={() => setF({ q: "", states: [], classes: [], ersaOnly: false })} className="px-2 text-xs font-medium text-sky-700 hover:text-sky-900" data-testid="pls-reset-filters">Reset all</button>
      )}
    </div>
  </div>
);
